import { getToken } from "../../../services/authService";

const API_BASE = process.env.REACT_APP_API_URL || "";
const api = (path) =>
    `${API_BASE.replace(/\/+$/, "")}/${String(path).replace(/^\/+/, "")}`;

async function apiFetch(path, opts = {}) {
    const token = getToken();
    const res = await fetch(api(path), {
        ...opts,
        headers: {
            Authorization: `Bearer ${token}`,
            ...(opts.headers || {}),
        },
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `HTTP ${res.status}`);
    }

    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) return res.json();
    return null;
}

export const eventosApi = {
    listAll: () => apiFetch("api/eventos/all"),
};
